import {
  Box,
  BoxProps,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import { formatDistance } from 'date-fns';
import { ReactNode } from 'react';
import { useColumnMenus } from '../Components/Map/SidebarAndMap/SidebarAndMap';
import { useWideScreen } from '../util/useWideScreen';
import styles from './truncate.module.css';

export const Sidebar = ({ children, height }: { children: ReactNode; height?: string }) => {
  const columnView = useColumnMenus();
  return (
    <Stack
      spacing={6}
      height={columnView && !height ? 'auto' : height}
      padding={1}
      paddingBottom={columnView ? '40px' : '0px'}
      overflow={'auto'}
    >
      {children}
    </Stack>
  );
};

export const Item = ({ children }: { children: ReactNode }) => (
  <Stack spacing={2}>{children}</Stack>
);

export const Header = ({ icon, children }: { icon: ReactNode; children: ReactNode }) => (
  <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
    <Box color="primary.main">{icon}</Box>
    <Typography variant="h5">{children}</Typography>
  </Stack>
);

export const DurationDescription = ({
  earlierIso8601,
  laterIso8601,
  sx,
}: {
  earlierIso8601: string;
  laterIso8601?: string;
  sx?: SxProps;
}) => {
  const description = formatDistance(
    new Date(earlierIso8601),
    laterIso8601 ? new Date(laterIso8601) : new Date(),
    {
      addSuffix: true,
    },
  );
  return (
    <Typography className={styles.truncateUnlessHover} sx={sx} variant="body2">
      {description}
    </Typography>
  );
};

export const SubHeader = ({
  icon,
  children,
  from,
  to,
}: {
  icon: ReactNode;
  children: ReactNode;
  from?: string;
  to?: string;
}) => {
  const isWidescreen = useWideScreen();
  return (
    <Stack direction="row" justifyContent="space-between">
      <Grid container direction="row" width="100%" justifyContent="left">
        <div>{icon}</div>
        {isWidescreen ? (
          <Typography variant="h6">{children}</Typography>
        ) : (
          <Typography fontWeight="bold">{children}</Typography>
        )}
      </Grid>
      {to && (
        <DurationDescription
          earlierIso8601={to}
          laterIso8601={from}
          sx={{
            height: 'max-content',
            justifyItems: 'self-end',
            width: 'fit-content !important',
            minWidth: 'max-content',
          }}
        />
      )}
    </Stack>
  );
};

export const PaperBox = ({ children, ...rest }: BoxProps) => (
  <Paper>
    <Box p={2} overflow="auto" {...rest}>
      {children}
    </Box>
  </Paper>
);

export const OffsetPreTags = ({ children }: { children: ReactNode }) => (
  <div style={{ marginLeft: '2.5rem', lineHeight: '0.5rem' }}>{children}</div>
);

export const CenteredProgress = () => (
  <Stack direction="row" justifyContent="center">
    <CircularProgress />
  </Stack>
);
